<template>
  <div>
    <main class="container">
      <table-header
        title="Шаблоны"
        :is-loading="isLoading"
        :is-empty="!templates.length"
      />
      <div class="table-wrapper">
        <div class="table-container">
          <transition
            name="fade"
            mode="out-in"
          >
            <table
              v-if="!isLoading && templates.length"
              class="table interactive"
            >
              <thead>
                <tr>
                  <th>
                    <div class="table__header_setings">
                      <i class="material-icons">tune</i>
                    </div>
                  </th>
                  <th
                    v-for="header in tableHeaders"
                    :key="header.key"
                    :class="[{'sortable sortable_asc': header.sortable}, getSortClass(header.key)]"
                    @click="changeSortKey(header.key, header.sortable)"
                  >
                    <div class="table__header">
                      {{ header.label }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(it, i) in templates"
                  :key="it.id"
                >
                  <td>
                    <template-actions
                      :template="templates[i]"
                      @editTemplate="openEditTemplateModal"
                    />
                  </td>
                  <td>{{ it.name }}</td>
                  <td>{{ it.subject }}</td>
                  <td>{{ it.to }}</td>
                  <td>{{ it.cc }}</td>
                  <td>{{ it.from }}</td>
                </tr>
              </tbody>
            </table>
          </transition>
        </div>
      </div>
      <table-footer
        v-if="templates.length && !isLoading"
        :current-page="currentPage"
        :per-page="perPage"
        :limit="limit"
        :total-count="totalCount"
        @pageChanged="(page) => currentPage = page"
        @limitChanged="(lim) => limit = lim"
      />
    </main>
    <edit-template-modal
      v-if="user"
      v-model="isEditTemplateModalShown"
      :template-edited="templateEdited"
      @editTemplate="editTemplate"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TableHeader from '@/components/table/TableHeader';
import TableFooter from '@/components/table/TableFooter';
import EditTemplateModal from '@/components/template-list/EditTemplate';
import TemplateActions from '@/components/template-list/TemplateActions';

export default {
  name: 'TemplateList',
  components: {
    TableHeader,
    TableFooter,
    EditTemplateModal,
    TemplateActions,
  },
  data: () => ({
    isLoading: true,
    templates: [],
    currentPage: 1,
    perPage: 10,
    limit: 10,
    totalCount: null,
    isEditTemplateModalShown: false,
    pageWatcherDisabled: false,
    templateEdited: {},
    sortReversed: false,
    sortKey: '',
    sort: '',
    tableHeaders: [
      {
        key: 'name',
        label: 'Имя',
        sortable: true,
      },
      {
        key: 'subject',
        label: 'Тема',
        sortable: true,
      },
      {
        key: 'to',
        label: 'Кому',
        sortable: true,
      },
      {
        key: 'cc',
        label: 'В копии',
        sortable: true,
      },
      {
        key: 'from',
        label: 'от',
        sortable: true,
      },
    ],
  }),
  computed: {
    ...mapState(['user', 'isBackgroundBlurred']),
    pages() {
      return Math.ceil(this.totalCount / this.perPage);
    },
    offset() {
      return this.limit * (this.currentPage - 1);
    },
  },
  watch: {
    limit() {
      this.pageWatcherDisabled = true;
      this.currentPage = 1;
      this.getTemplates();
    },
    currentPage() {
      if (this.pageWatcherDisabled) {
        return;
      }

      this.getTemplates();
    },
    isEditTemplateModalShown(value) {
      this.$store.commit('setBackgroundBlur', value);
    },
  },
  created() {
    this.getTemplates();
  },
  methods: {
    async getTemplates() {
      this.isLoading = true;
      const { items, total } = await this.$http.get('mailer/1.0/templates', {
        params: {
          // limit: this.limit,
          skip: this.offset,
          sort: this.sort,
        },
      });

      this.isLoading = false;

      this.templates = items;
      this.totalCount = total;
      this.perPage = this.limit;
      this.pageWatcherDisabled = false;

      return Promise.resolve();
    },
    async editTemplate() {
      await this.getTemplates();
      this.isEditTemplateModalShown = false;
    },
    openEditTemplateModal(template) {
      this.isEditTemplateModalShown = true;
      this.templateEdited = template;
    },
    changeSortKey(sortKey, sortable) {
      if (this.isLoading || !sortable) {
        return;
      }

      this.sortReversed = this.sortKey === sortKey ? !this.sortReversed : false;
      this.sortKey = sortKey;

      this.sort = (this.sortReversed ? '-' : '+') + this.sortKey;
      this.pageWatcherDisabled = true;
      this.currentPage = 1;
      this.getTemplates();
    },
    getSortClass(sortKey) {
      return { [`sortable_active ${this.sortReversed ? 'sortable_desc' : 'sortable_asc'}`]: this.sortKey === sortKey };
    },
  },
};
</script>
